import { Socket } from 'socket.io-client'
import { MULTI_PERSON_SERVER_URL } from '@api/index'
import socketClient from 'common/utils/socket'

class QueueOrderingController {
  constructor (storeId: number, queueId: number) {
    this.storeId = storeId
    this.queueId = queueId

    // 创建连接key
    this.initSocketKey(storeId, queueId)

    // 创建socket实例
    this.socket = socketClient.open(MULTI_PERSON_SERVER_URL, () => {
      this.init()
    })
  }
  /** socket实例 */
  private socket: Socket
  /** 门店id */
  storeId: number
  /** 排队id */
  queueId: number
  /** socket key */
  private socketKey: string = ''
  /** 生成socket key */
  private initSocketKey (storeId: number, queueId: number) {
    this.socketKey = `${storeId}__${queueId}`
  }
  /** 用户进入后进行初始化操作 */
  async init () {
    this.joinRoom()
  }
  /** 用户进来加入点餐房间 */
  private async joinRoom () {
    this.socket.emit('joinRoom', { room: this.socketKey })
  }
  /** 监听事件 */
  on (type: any, fn: (data: object) => any) {
    this.socket.on(type, (data) => {
      fn(data)
    })
  }
  /** 关闭连接 */
  close () {
    socketClient.close()
  }
}

export default QueueOrderingController
